let _time = 0
let _timer = null
function timeFormat(s) {
  var hours = Math.floor(s / 60 / 60);
  var minutes = Math.floor(s / 60);// - (hours * 60);
  var seconds = s % 60;
  return timePrettify(minutes)+":"+timePrettify(seconds)
}
function timePrettify(t) {
  return t < 10 ? "0"+t : t
}
export function start() {
  if(!_timer) {
    _timer = setInterval(() => {
      _time++
      //console.log("TICK,", _time)
    }, 1000)
  }
}
export function stop() {
  clearInterval(_timer)
  _timer = null
}
export function reset() {
  stop()
  _time = 0
}
export function getTime() {
  return _time
}
export function getTimeMMSS() {
  return timeFormat(_time)
}
